<template>
  <div class="mobile-preview relative" ref="mb_preview">
    <div class="mobile-head" ref="mb_head">
      <img src="/images/top-mb.png" alt="top-mb" />
    </div>
    <div class="mobile-bottom" ref="mb_bottom">
      <img src="/images/bottom-mb.png" alt="bottom-mb" />
      <span></span>
    </div>
    <div class="mobile-background">
      <div
        ref="mb_bg"
        class="mobile-background__style overflow-y-auto scrollbar-thin scrollbar-thumb-gray-600 scrollbar-track-gray-300 bg-[#f3f3f3]"
        style="margin-top: 85px; margin-bottom: 43px;"
      >
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup></script>

<style scoped lang="scss">
.mobile-preview {
  border-radius: 42px;
  box-shadow: 0 2px 8px 0 #00000026;
  width: 380px;
  padding: 0 8px 8px;
  overflow: hidden;
  background-size: calc(100% - 2px) 100%;
  background-repeat: repeat-y;
  background-image: url(/images/middle.png);
  background-position-x: 1px;
  box-sizing: border-box;
  .mobile-head,
  .mobile-bottom {
    position: absolute;
    background-color: white;
    left: 1px;
    z-index: 10;
    width: calc(100% - 2px);
    img {
      width: 100%;
    }
  }
  .mobile-bottom {
    bottom: 0px;
  }
  .mobile-background {
    margin: auto;
    position: relative;
    height: calc(100% - 8px);
    top: 4px;
    border-radius: 20px;
    overflow: hidden;
    .mobile-background__style {
      height: 500px;
      width: 100%;
    }
  }
}
</style>
